import React from 'react';

const PastWorkshop = () => {
  return (
    <div>
      <section className="page-hero">
        <h1>Past Workshops</h1>
        <p>Previous workshop events</p>
      </section>
      <section className="page-content">
        <div className="container">
          <p style={{color: '#E6D88A', textAlign: 'center', fontSize: '1.1rem'}}>
            No past workshops available at this time.
          </p>
        </div>
      </section>
    </div>
  );
};

export default PastWorkshop;